<template>
    <div>
        <div style="padding:15px;">
            <img :src="require('@/assets/images/coach_register/coach_regi_screen_x_btn.png')" style="width:14px; height:14px;" @click="() => {$GlobalStore.closeLastModal()}">
        </div>
        <div style="flex:1; padding:12px 12px; display:flex; flex-direction: column">
            <template v-if="type === COACH_DOC_REGISTER_TYPE.DEFAULT_INFO">
                <div class="explain_container">
                    <div class="title">기본 정보</div>
                    <div class="contents">기본 정보를 입력하세요</div>
                </div>
                <div style="flex:1;">
                    <div class="label">이름</div>
                    <input class="register_input" type="text" placeholder="이름을 입력하세요" readonly :value="$GlobalStore.loginInfo().name">
                    <div style="margin-top:5px; color:#606060; font-size:12px; font-weight:500;">정확한 이름을 입력해주세요.</div>

                    <div class="label">주민등록등본</div>
                    <div class="file_name" :class="[file0_name ? 'active' : '']">{{file0_name ? file0_name : 'pdf, jpg, jpeg, png 형식으로 제출해 주세요.'}}</div>
                    <input type="file" name="file0" id="coach_doc_register_file0" style="display:none;" data-index="0" @change="checkExtension($event)">
                    <div v-if="file0_name === ''" class="add_btn" @click="addFile(0)">파일 첨부하기</div>
                    <div v-else class="add_btn" @click="deleteFile(0)">파일 삭제하기</div>
                </div>
                <div class="btn_wrap">
                    <div class="btn" :class="[file0_name ? 'active' : 'inactive']" @click="goPlayerCareer">다음</div>
                </div>
            </template>
            <template v-if="type === COACH_DOC_REGISTER_TYPE.PLAYER_CAREER">
                <div class="explain_container">
                    <div class="title">선수 이력</div>
                    <div class="contents">선수경력을 인증할 수 있는 증명서를 첨부하세요</div>
                    <div class="contents2">조인KFA에서 수경력증명서를 제출해야 합니다. </div>
                </div>
                <div style="flex:1;">
                    <div style="height:250px; text-align:center;">
                        <img :src="require('@/assets/images/coach_register/coach_regi_career.png')" style="width:180px;">
                    </div>

                    <div class="label">조인KFA 선수경력증명서</div>
                    <div class="file_name" :class="[file1_name ? 'active' : '']">{{file1_name ? file1_name : 'pdf, jpg, jpeg, png 형식으로 제출해 주세요.'}}</div>
                    <input type="file" name="file1" id="coach_doc_register_file1" style="display:none;" data-index="1" @change="checkExtension($event)">
                    <div v-if="file1_name === ''" class="add_btn" @click="addFile(1)">파일 첨부하기</div>
                    <div v-else class="add_btn" @click="deleteFile(1)">파일 삭제하기</div>
                </div>
                <div class="btn_wrap">
                    <div class="btn" style="flex:1;" @click="() => {$GlobalStore.closeLastModal()}">이전</div>
                    <div class="btn" style="flex:2;" :class="[file1_name ? 'active' : 'inactive']" @click="goBank">다음</div>
                </div>
            </template>
            <template v-if="type === COACH_DOC_REGISTER_TYPE.BANK">
                <div class="explain_container">
                    <div class="title">수익 창출</div>
                    <div class="contents">수익을 정산 받을 계좌를 입력하세요</div>
                </div>
                <div style="flex:1;">
                    <div class="label">은행</div>
                    <!--<input class="register_input" type="text" v-model="bank_name">-->
                    <div @click="showPopMenu" class="common_box" style="position: relative; line-height: 24px; color: #bbbbbb; font-weight: 500; width: 120px; display: flex; align-items: center; gap: 12px; justify-content: space-between">
                        <div :style="{ color: bank_name === '' ? '' : '#210f03' }" style="font-size: 14px">{{ bank_name === "" ? "선택" : bank_name }}</div>
                        <img style="width: 10px; transform: rotate(90deg)" :src="require('@/assets/img/arrow_tick.png')" alt="" />
                        <MemberTalkPopMenuOption v-if="isShowPopMenu" :right="-173" :top="43" v-bind="popMenuOptions" :max-height="'200px'"></MemberTalkPopMenuOption>
                    </div>

                    <div class="label">계좌번호</div>
                    <div style="position:relative;">
                        <input class="register_input" type="text" v-model="bank_account_number" placeholder="계좌번호를 입력하세요">
                        <img v-if="bank_account_number.length > 0" style="position:absolute; right:10px; top:14px;width:20px; height:20px;" :src="require('@/assets/images/coach_register/coach_regi_x_btn.png')" @click="() => {bank_account_number = ''}">
                    </div>
                    <div class="label">조인KFA 선수경력증명서</div>
                    <div class="file_name" :class="[file2_name ? 'active' : '']">{{file2_name ? file2_name : 'pdf, jpg, jpeg, png 형식으로 제출해 주세요.'}}</div>
                    <input type="file" name="file2" id="coach_doc_register_file2" style="display:none;" data-index="2" @change="checkExtension($event)">

                    <div v-if="file2_name === ''" class="add_btn" @click="addFile(2)">파일 첨부하기</div>
                    <div v-else class="add_btn" @click="deleteFile(2)">파일 삭제하기</div>

                </div>
                <div class="btn_wrap">
                    <div class="btn" style="flex:1;" @click="() => {$GlobalStore.closeLastModal()}">이전</div>
                    <div class="btn" :class="[is_can_submit ? 'active' : 'inactive']" style="flex:2;" @click="submit">최종 제출하기</div>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
    import {FORM_MODE} from "../../../Constants";
    import ResponseCode from "../../../ResponseCode";
    import {COACH_DOC_COMPLETE} from "./CoachDocComplete";
    import MemberTalkPopMenuOption from "../../common/MemberTalkPopMenuOption";

    export const COACH_DOC_REGISTER_TYPE = {
        DEFAULT_INFO : 0,
        PLAYER_CAREER : 1,
        BANK : 2,
    }

    export default {
        name: "CoachDocRegister",
        components: {MemberTalkPopMenuOption},
        props : {
            type : {
                type : Number,
                default : -1,
            },
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        computed : {
            is_can_submit(){
                return this.file2_name !== '' && this.bank_name !== '' && this.bank_account_number !== ''
            }
        },
        data(){
            return {
                COACH_DOC_REGISTER_TYPE : COACH_DOC_REGISTER_TYPE,
                file0_name : '',
                file1_name : '',
                file2_name : '',
                bank_name : '',
                bank_account_number : '',
                isShowPopMenu : false,
                popMenuOptions : {}
            }
        },
        methods : {
            showPopMenu(){
                this.isShowPopMenu = true;
            },
            goPlayerCareer(){
                if(this.file0_name === '') return;
                this.$GlobalStore.addModal('CoachDocRegister', {mode : this.mode, type : COACH_DOC_REGISTER_TYPE.PLAYER_CAREER});
            },
            goBank(){
                if(this.file1_name === '') return;
                this.$GlobalStore.addModal('CoachDocRegister', {mode : this.mode, type : COACH_DOC_REGISTER_TYPE.BANK});
            },
            addFile(index){
                document.getElementById('coach_doc_register_file' + index).click();
            },
            deleteFile(index){
                document.getElementById('coach_doc_register_file' + index).value = '';
                this['file' + index + '_name'] = '';
            },
            checkExtension(e) {
                const input = e.currentTarget;

                if (input.files && input.files[0]) {
                    var extension = input.files[0].name.split('.').pop().toLowerCase();
                    const index = input.getAttribute('data-index');
                    if(extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp'){
                        this['file' + index + '_name'] = input.files[0].name;
                        var reader = new FileReader();
                        reader.onload = (e) => {e;}
                        reader.readAsDataURL(input.files[0]);
                    }else {
                        this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                        this['file' + index + '_name'] = '';
                    }
                }
            },
            async submit(){
                if(!document.getElementById('coach_doc_register_file0').files[0]){
                    this.$GlobalStore.showAlert('기본정보 파일을 첨부해주세요.');
                    return;
                }

                if(!document.getElementById('coach_doc_register_file1').files[0]){
                    this.$GlobalStore.showAlert('선수이력 파일을 첨부해주세요.');
                    return;
                }

                if(!document.getElementById('coach_doc_register_file2').files[0]){
                    this.$GlobalStore.showAlert('통장사본 파일을 첨부해주세요.');
                    return;
                }

                if(this.bank_name === ''){
                    this.$GlobalStore.showAlert('은행을 선택해주세요.');
                    return;
                }

                if(this.bank_account_number === ''){
                    this.$GlobalStore.showAlert('계좌번호를 선택해주세요.');
                    return;
                }

                const formData = new FormData();
                formData.append('mode', FORM_MODE.INSERT);
                formData.append('file0', document.getElementById('coach_doc_register_file0').files[0]);
                formData.append('file1', document.getElementById('coach_doc_register_file1').files[0]);
                formData.append('file2', document.getElementById('coach_doc_register_file2').files[0]);

                this.$Util.sendEventClick('코치서류등록_제출');

                this.$GlobalStore.showProgress();

                const res = await this.$Axios.post('/api/player_cert/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                if (res.data.code === ResponseCode.SUCCESS) {
                    const parameters = {};
                    parameters.mode = FORM_MODE.INSERT;
                    parameters.account_owner_name = this.$GlobalStore.loginInfo().name;
                    parameters.account_number = this.bank_account_number;
                    parameters.bank_name = this.bank_name;
                    const res2 = await this.$Axios.post('/api/bank/account/save', parameters);
                    this.$GlobalStore.hideProgress();
                    if (res2.data.code === ResponseCode.SUCCESS) {
                        this.$GlobalStore.closeSpliceModal('CoachRegisterExplanation');
                        this.$GlobalStore.addModal('CoachDocComplete', {type : COACH_DOC_COMPLETE.COMPLETE});
                        this.completeAction();
                    } else if (res2.data.code === ResponseCode.FAIL) {
                        this.$GlobalStore.showAlert(res.data.msg);
                    }

                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.hideProgress();
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        created(){
            this.submit = this.$Once(this.submit);

            if(this.type === COACH_DOC_REGISTER_TYPE.BANK){
                const banks = ['NH농협', '카카오뱅크', 'KB국민', '신한', '토스뱅크', '우리', 'IBK기업', '하나', '새마을', '부산', '대구',
                    '케이뱅크', '신협', '우체국', 'SC제일', '경남', '광주', '수협', '전북', '저축은행', '제주', '씨티', 'KDB산업', 'SBI저축은행'];

                const labelAndAction = [];
                for(const each of banks){
                    labelAndAction.push(
                        {
                            label: each,
                            action: async () => {
                                this.bank_name = each;
                                this.isShowPopMenu = false;
                            },
                            fontColor: "#210f03",
                        }
                    )
                }

                this.popMenuOptions = {
                    labelAndAction: labelAndAction,
                    closeAction: () => {
                        this.isShowPopMenu = false;
                    },
                };
            }
        }
    }
</script>

<style scoped>
    .explain_container{padding: 20px;}
    .title{color:#210F03; font-weight:bold; font-size:32px; text-align:center;}
    .contents{color:#210F03; font-size:16px; font-weight:500; text-align:center; margin-top:10px;}
    .contents2{color:#606060; font-size:12px; font-weight:500; margin-top:10px; text-align:center;}

    .label{margin-top:30px; color:#210F03; font-size:16px; font-weight:500; margin-bottom:10px;}
    .file_name{color:#BBBBBB; border-bottom:1px solid #EBEBEB; padding-bottom:8px;}
    .file_name.active{color:#210F03; font-size:16px; font-weight:500;}
    .add_btn{padding:10px 10px; padding-left:0px; display:inline-block; color:#699BF7; font-size:14px; font-weight: bold;}
    .register_input{border:0px; border-radius:12px; height:48px; outline: none; background-color: #f5f5f5; font-size:14px; font-weight:500; color:#210F03; padding-left:12px; padding-right:30px; width:100%;}
    .btn_wrap{display:flex; gap: 20px;}
    .btn{flex:1;display:grid; place-items:center; height:46px; border-radius:12px; background-color: #EDEDED; font-size:14px; font-weight:bold;}
    .btn.inactive{color:#D9D9D9; color:#D9D9D9;}
    .btn.active{color:white; background-color:black;}

    .common_box {
        padding: 12px;
        background-color: #f5f5f5;
        border-radius: 12px;
    }

</style>